import axios from 'axios';
import { apiAddress } from 'config';

export const getLatestBlockInfo =
  async (): Promise<LatestBlockInfoType | null> => {
    const url = `${apiAddress}/blocks/latest`;
    const response = await axios.get(url);
    if (response.status < 300) {
      return response.data;
    }
    return null;
  };

export interface LatestBlockInfoType {
  hash: string;
  epoch: number;
  nonce: number;
  prevHash: string;
  proposer: string;
  pubKeyBitmap: string;
  round: number;
  shard: number;
  size: number;
  sizeTxs: number;
  stateRootHash: string;
  timestamp: number;
  txCount: number;
  gasConsumed: number;
  gasRefunded: number;
  gasPenalized: number;
  maxGasLimit: number;
  scheduledRootHash: string;
}
